import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1fa7ba86")
const _hoisted_1 = { class: "qgroup-container" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "header-question-type" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "card-options" }
const _hoisted_6 = {
  key: 0,
  class: "options-question-true-or-false"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "option-item" }, "A. 正确", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "option-item" }, "B. 错误", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "options-question-container"
}
const _hoisted_11 = { class: "option-index" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "card-analysis" }
const _hoisted_14 = ["innerHTML"]
_popScopeId()

import { computed } from 'vue'
enum QuestionType {
  SingleChoice = 1,
  MultipleChoice = 2,
  TrueFalse = 4
}

export default /*#__PURE__*/_defineComponent({
  props: {
  qgroupInfo: Object
},
  setup(__props) {

const props = __props

const questions = computed(() => props.qgroupInfo?.questions || [])

const questionTypeMap: Record<QuestionType, string> = {
  [QuestionType.SingleChoice]: '单选题',
  [QuestionType.MultipleChoice]: '多选题',
  [QuestionType.TrueFalse]: '判断题'
}

const getCardCorrectAnswer = (item: any) => {
  let answer = ''
  switch (item.type) {
  case QuestionType.SingleChoice: {
    item.question_params.options.forEach(
      (option: any, index: number) => {
        if (option.is_correct) {
          answer += String.fromCharCode(65 + index)
        }
      }
    )
    break
  }
  case QuestionType.MultipleChoice: {
    item.question_params.options.forEach(
      (option: any, index: number) => {
        if (option.is_correct) {
          answer +=
                  answer === ''
                    ? String.fromCharCode(65 + index)
                    : '、 ' + String.fromCharCode(65 + index)
        }
      }
    )
    break
  }
  case QuestionType.TrueFalse: {
    answer =
            item.question_params.is_correct === 1
              ? '正确'
              : '错误'
    break
  }
  default:
    break
  }
  return answer + '。'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questions), (question, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "qgroup-card",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(index + 1) + ".", 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(questionTypeMap[question.type]), 1),
          _createElementVNode("div", {
            class: "header-question-title",
            innerHTML: question.title
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (question.type === QuestionType.TrueFalse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.question_params.options, (option, _optionIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "question-option-item",
                    key: _optionIndex
                  }, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(String.fromCharCode(65 + _optionIndex)) + ". ", 1),
                    _createElementVNode("div", {
                      innerHTML: option.content
                    }, null, 8, _hoisted_12)
                  ]))
                }), 128))
              ]))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, " 答案: " + _toDisplayString(getCardCorrectAnswer(question)), 1),
          _createElementVNode("div", {
            innerHTML: question?.analysis
          }, null, 8, _hoisted_14)
        ])
      ]))
    }), 128))
  ]))
}
}

})